window.ModalMarkets = (function () {
	return {
	    init: function (content, ajaxCall, callbacks) {
			var self = this;

			self.ajaxCall = ajaxCall;
			self.dom = {};

			self.marketsModal = new app.ModalWindow({
				content: content,
				title: window.Localization.getString('Scripts_Shared_Modules.ModalMarkets_28', 'Добавить рынки'),
				className: 'modal-markets-wrapper',
				afterShow: function () {
					self.dom.body = $('[js-node="modal-markets__body"]');
					self.dom.submit = $('[js-node="modal-markets__submit"]');
					self.dom.markets = $('[name="modal-markets-market"]');
					self.dom.selectAllBtn = $('[js-node="modal-markets__select-all"]');
					self.dom.selectDefaultBtn = $('[js-node="modal-markets__select-default"]');

					self.bindUI();
					self.checkButtonsState();

					if (callbacks !== undefined && callbacks.afterShow !== undefined && typeof (callbacks.afterShow) === 'function') {
						callbacks.afterShow();
					}
				},
				afterHide: function () {
					self.clear.call(self);
					if (callbacks !== undefined && callbacks.afterHide !== undefined && typeof (callbacks.afterHide) === 'function') {
						callbacks.afterHide();
					}
				}
			});
			self.marketsModal.show();

		},
		bindUI: function () {
			var self = this;

			//EVENT: Отправить рынки
			self.dom.submit.on('click', function () {
				var checkedMarkets = $(app.ModalMarkets.dom.markets).filter(':checked');
				if (app.ModalMarkets.dom.markets.length > 0 && checkedMarkets.length === 0) {
					self.marketsModal.dom.body.fadeOut().fadeIn();
					return;
				}

				var checkedIds = [];
				checkedMarkets.each(function () {
					checkedIds.push(this.value);
				});

				if (self.ajaxCall !== undefined && typeof (self.ajaxCall) === 'function') {
				    self.ajaxCall(checkedIds);
				}
				self.marketsModal.hide();
			});

			self.dom.selectAllBtn.on('click', function () {
				self.toggleAll($(this).prop('checked'));
				self.checkButtonsState();
			});

			self.dom.selectDefaultBtn.on('click', function () {
				self.selectDefault();
				self.checkButtonsState();
			});

			// при клике на чекбокс рынка проверяем если выбраны все / все по умолчанию						
			self.dom.markets.on('click', function () {
				self.checkButtonsState();
			});
		},
		clear: function () {
			delete this.dom;
			delete this.marketsModal;
			delete this.ajaxCall;
		},
		toggleAll: function (selected) {
			this.dom.markets.each(function () {
				$(this).prop('checked', selected);
			});
		},
		selectDefault: function () {
			this.dom.markets.each(function () {
				if ($(this).data('default') === 1)
					$(this).prop('checked', true);
				else
					$(this).prop('checked', false);
			});
		},
		checkButtonsState: function () {
			var checkedAll = true,
					checkedOnlyDefaults = true;

			this.dom.markets.each(function () {
				var marketInput = $(this);

				// пусть кнопка "по умолчанию" будет всегда активна				
				/*if (marketInput.prop('checked') === false && marketInput.data('default') === 1 || marketInput.prop('checked') === true && marketInput.data('default') === 0)
					checkedOnlyDefaults = false;*/

				if (marketInput.prop('checked') === false)
					checkedAll = false;
			});

			this.setCheckAllBtnState(checkedAll);
			//this.setCheckDefaultsBtnState(checkedOnlyDefaults);
		},
		setCheckAllBtnState: function (state) {
			this.dom.selectAllBtn.prop('checked', state);
		},
		setCheckDefaultsBtnState: function (isAllChecked) {			
			if (isAllChecked === true)
				this.dom.selectDefaultBtn.addClass('disabled');
			else
				this.dom.selectDefaultBtn.removeClass('disabled');
		}
	}
}());